import { Amplify } from 'aws-amplify';
import { getAmplifyConfiguration } from '../baselineApis';

export const configureAmplify = () => {
  Amplify.configure({
    Auth: getAmplifyConfiguration(),
  });
};
